{
  "generic": {
    "loadingData": "Kunne ikke laste data",
    "saveFailed": "Kunne ikke lagre",
    "tryAgainLater": "Vennligst prøv igjen senere."
  },
  "required": "Dette feltet er obligatorisk",
  "maxLength": "Feltet kan ikke ha mer enn {{maxLength}} tegn",
  "minumumLength": "Feltet må ha minst {{minLength}} tegn",
  "email": "Ugyldig e-postadresse",
  "emailPhoneRequired": "E-post eller telefonnummer er obligatorisk",
  "houseNumberMaxLength": "Husnummer kan ikke være lengre enn 50 tegn",
  "postNumberMaxLength": "Postnummer kan ikke ha mer enn fire siffer",
  "postNumberMinLength": "Postnummer må ha fire siffer",
  "machineId": {
    "invalidFormat": "Maskin ID kan kun bestå av 5 siffer"
  },
  "contactPreference": {
    "emailRequiresEmail": "For å velge E-post må du fylle ut e-postadresse",
    "postRequiresAddress": "For å velge post må du fylle ut adresse under kontaktpreferanser",
    "smsRequiresPhone": "For å velge SMS må du fylle ut telefonnummer"
  },
  "organization": {
    "alreadyExists": "Skogeier kan kun knyttes til en organisasjon. Fjern den valgte organisasjonen før du legger til ny.",
    "invalidFormat": "Organisasjonsnummeret må bestå av 9 siffer.",
    "notFound": "Finner ikke organisasjonsnummeret i Brønnøysundregistrene. Sjekk at det er riktig.",
    "serviceUnavailable": "Kunne ikke hente informasjon fra Brønnøysundregistrene. Prøv igjen senere."
  },
  "salesAgreement": {
    "orderNumber": {
      "invalidLength": "Bestillingsnummeret må ha nøyaktig 8 siffer"
    },
    "commission": {
      "invalidType": "Provisjon må være et gyldig tall",
      "range": "Provisjon må være mellom 0 og 100"
    },
    "certificateText": {
      "maxLength": "Sertifikattekst kan ikke ha mer enn {{maxLength}} tegn"
    },
    "validTo": {
      "afterValidFrom": "Sluttdato må være etter startdato"
    }
  },
  "file": {
    "exclusiveOwnershipAlreadyExists": "Det finnes allerede et eksklusiv bruksrett dokument registrert på denne eiendommen.",
    "duplicateOwnership": "Det finnes allerede en eierskapstype registrert på denne eiendommen.",
    "uploadFailed": "Kunne ikke laste opp filen. Prøv igjen.",
    "duplicateOwnershipLegalOwner": "Eiendommen din har allerede et dokument av denne typen fra en annen eier. Ta kontakt med support for hjelp.",
    "cooperativeMembershipConflict": "Kunne ikke oppdatere eierskap – eiendommen er koblet til et samvirkemedlemskap som ikke samsvarer med denne skogeieren. Ta kontakt med support for hjelp.",
    "uploadRequired": "Du må laste opp fullmaktsdokument eller velge å laste opp senere",
    "uploadRequiredMandatory": "Du må laste opp fullmaktsdokument",
    "documentsRequired": "Du må laste opp minst ett dokument"
  }
}
